<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-8 pb-5">
            <div class="row">
              <div class="col-md-6">
                <div
                  class="dashboard__card large_card indus_back_img"
                  :style="[
                    {
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                    },
                  ]"
                >
                  <div class="row align-items-center larg_inner__row">
                    <div class="col-md-4 larg_inner__row_left">
                      <img src="@/assets/img/money (3).svg" width="70" />
                    </div>
                    <div class="col-md-8 larg_inner__row_right">
                      <div>
                        <h6 class="text-white">
                          {{ $t("text.iWalletBalance.title") }}
                        </h6>
                      </div>
                      <h5 class="text-white mt-4" v-if="!showLoader">
                        <!-- {{ $n(walletBalance, 'currency') }} -->
                        {{ industryBranch ? industryBranch.currencyCode : "" }}
                        {{ walletBalance }}
                      </h5>
                      <pulse-loader
                        size="15px"
                        v-if="showLoader"
                        class="mt-4"
                      ></pulse-loader>
                      <div class="mt-4">
                        <!-- <button class="btn btn_primary">Add Funds</button> -->

                        <!-- <button :style="[{cursor: 'not-allowed'} ]"   class="vue_router_link btn btn_primary" :disabled="true">
                                                Coming Soon
                                            </button> -->
                        <router-link
                          :to="{
                            name: 'industrialBranchFundWallet',
                            query: this.$route.query.branchId
                              ? this.linkQuery
                              : ' ',
                            groupId: this.$route.query.groupId,
                          }"
                          class="vue_router_link btn btn_primary"
                          v-if="!showLoader"
                        >
                          {{ $t("text.iWalletBalance.addFunds") }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-padding-left padding_div_1">
                <div class="dashboard__card small_card">
                  <div class="small__card_content_wrapper">
                    <h5
                      style="font-size: 13px; font-weight: bold"
                      class="dashboard__card__header"
                    >
                      {{ $t("text.iWalletBalance.totalExpenses") }}
                    </h5>
                    <div class="car_content_flex_wrapper mt-3">
                      <img src="@/assets/img/Page-1 (3).svg" width="40px" />
                    </div>
                    <div class="mt-3">
                      <h3
                        class="dashboard__card__header_bottom"
                        v-if="!showLoader"
                      >
                        {{ industryBranch ? industryBranch.currencyCode : "" }}
                        {{ totalExpenses }}
                        <!-- {{ $n(totalExpenses, 'currency') }} -->
                      </h3>
                      <pulse-loader
                        size="15px"
                        v-if="showLoader"
                      ></pulse-loader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="showLoaderDiv charts__loader w-full mt-5 mx-auto"
              style="width: 100%; height: 100%"
              v-if="showLoader"
            >
              <div :class="showLoader ? 'loading' : null"></div>
            </div>
            <div class="section__wrapper mt-3" v-if="!showLoader">
              <highcharts
                :options="walletStatisticsChart"
                class=""
                style="padding-top: 20px"
              ></highcharts>
            </div>
          </div>
          <div class="col-md-4 remove-padding-left padding_div">
            <div class="transaction_summary_wrapper">
              <div class="header_container">
                <h3 class="sumamry_header">
                  {{ $t("text.iWalletBalance.transactionSummary") }}
                </h3>
              </div>
              <TableLoader :showLoader="showLoader" />
              <div class="list__container" v-if="!showLoader">
                <div
                  class="summary_list_container"
                  v-for="(ws, i) in walletStatistics"
                  :key="i"
                >
                  <div class="summary_list_card">
                    <div class="row summary_list_card_row">
                      <div class="col-md-8">
                        <div class="row align-items-center summary__row">
                          <div
                            class="col-md-4 summary_list_card_row_left remove-padding-left"
                          >
                            <div
                              class="icon_wrapper top-up"
                              v-if="ws.status === 'Credit'"
                            >
                              <img
                                src="@/assets/img/wallet (1).svg"
                                width="35"
                              />
                            </div>
                            <div
                              class="icon_wrapper diesel"
                              v-if="ws.status === 'Debit'"
                            >
                              <img
                                src="@/assets/img/wallet_debt.svg"
                                width="35"
                              />
                            </div>
                          </div>
                          <div class="col-md-8 summary_list_card_row_right">
                            <h6
                              style="font-size: 13px; font-weight: bold"
                              class="card_top_header"
                            >
                              {{ ws.source }}
                            </h6>
                            <h6 class="card_bottom_header mt-3">
                              <!-- {{ $n(ws.amount, 'currency') }} -->
                              {{
                                industryBranch
                                  ? industryBranch.currencyCode
                                  : ""
                              }}
                              {{ ws.amount }}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <h6
                              style="font-size: 12px; font-weight: bold"
                              class="time__stamps"
                            >
                              {{ ws.date }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="text-center button_wrapper mb-4"
                  style="
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                  "
                >
                  <router-link
                    v-if="walletTransactionsCount > 5"
                    class="btn btn_theme vue_router_link"
                    :to="{
                      name: 'industrialBranchWalletTransactionDetails',
                      query: this.$route.query.branchId ? this.linkQuery : ' ',
                      groupId: this.$route.query.groupId,
                    }"
                  >
                    {{ $t("text.iWalletBalance.viewMore") }}
                  </router-link>
                  <h6 class="time_stamps" v-if="walletTransactionsCount < 1">
                    {{ $t("text.iWalletBalance.noTransaction") }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  title: "Customer Dashboard:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
    PulseLoader,
  },
  data() {
    return {
      linkQuery: {
        branchId: this.$route.query.branchId,
        companyId: this.$route.query.companyId,
      },
      showLoader: true,
      totalExpenses: 0,
      walletBalance: 0,
      walletStatistics: [],
      walletTransactionsCount: 0,
      walletTransactionStartDate: this.$moment()
        .subtract(71, "days")
        .format("D-M-YYYY"),
      walletTransactionEndDate: this.$moment().format("D-M-YYYY"),
      startDate: this.$moment().subtract(70, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      industryBranch: null,
      industryBranchId: null,
      walletStatisticsChart: {
        chart: {
          type: "spline",
        },
        title: {
          text: this.$t("text.iWalletBalance.walletStatistics"),
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iWalletBalance.amount", {
              currency: `(${this.$store.getters.getCountryProducts.currency})`,
            }),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
    };
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
        this.getWalletTransactions();
        this.getWalletBalance();
      }
    },
  },
  computed: {
    walletStartDate() {
      return this.$moment(this.walletTransactionStartDate, "DD-MM-YYYY")
        .subtract(7, "days")
        .format("MMMM D, YYYY");
    },
    walletEndDate() {
      return this.$moment(this.walletTransactionEndDate, "DD-MM-YYYY").format(
        "MMMM D, YYYY"
      );
    },
  },
  mounted() {
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      document.querySelector(".padding_div").style.marginTop = "15px";

      document
        .querySelector(".padding_div_1")
        .classList.remove("remove-padding-left");
      document.querySelector(".padding_div_1").style.marginTop = "15px";
    }
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  methods: {
    getWalletTransactions() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RemisWalletTransactions/${this.industryBranch.id}?startDate=${this.walletStartDate}&endDate=${this.walletEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.walletTransactionsCount = res.data.length;
          this.showLoader = false;
          res.data.forEach((el) => {
            if (el.status.toLowerCase() === "add") {
              el.status = "Credit";
            }
          });
          this.parseWalletStatisticsChart([...res.data]);
          let expenses = res.data.filter((el) => el.status === "Debit");
          let credit = res.data.filter((el) => el.status === "Credit");
          let totalExpenses = expenses.reduce((acc, cur) => {
            return (acc += cur.amount);
          }, 0);
          let totalCredit = credit.reduce((acc, cur) => {
            return (acc += cur.amount);
          }, 0);
          this.totalExpenses = this.convertThousand(totalExpenses);
          res.data.forEach((el) => {
            el.amount = this.convertThousand(el.amount);
          });
          res.data.sort((a, b) => {
            if (a.date !== b.date) {
              return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
            }
          });

          this.walletStatistics = res.data.splice(0, 5);
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getWalletBalance() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/branchremiswallet/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.walletBalance = this.convertThousand(res.data.balance);
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parseWalletStatisticsChart(data) {
      const copiedData = [...data].splice(0, 5);
      let expenses = copiedData.filter((el) => el.status === "Debit");
      let credit = copiedData.filter((el) => el.status === "Credit");
      let expensesArr = [];
      let creditArr = [];
      let cats = [];

      copiedData.forEach((el) => {
        el.date = this.$moment(el.date).format("D-MM-YYYY");
      });

      credit.forEach((el) => {
        creditArr.push(el.amount);
        cats.push(el.date);
      });

      expenses.forEach((el) => {
        expensesArr.push(el.amount);
        cats.push(el.date);
      });

      let expenseSeries = [
        {
          name: this.$t("text.iWalletBalance.expenses"),
          color: "#F45067",
          data: expensesArr,
        },
      ];

      let creditSeries = [
        {
          name: this.$t("text.iWalletBalance.income"),
          color: "#1BC167",
          data: creditArr,
        },
      ];

      this.walletStatisticsChart.series = [...expenseSeries, ...creditSeries];
      this.walletStatisticsChart.xAxis.categories = cats;
    },
  },
};
</script>
